<template>
  <FocusTrap
    :active="opened"
    :initial-focus="() => $refs.overlayContent"
    :fallback-focus="() => $refs.overlayContainer"
    :return-focus-on-deactivate="true"
  >
    <div
      ref="overlayContainer"
      class="overlay-container"
      :class="{ opened: opened }"
      tabindex="-1"
    >
      <main ref="overlayContent" class="overlay-content" tabindex="-1">
        <span
          class="overlay-close icon hoverable-icon"
          tabindex="0"
          @click.stop="close"
          @keyup.enter="close"
        >
          <i class="fa-solid fa-times fa-lg" />
        </span>
        <slot />
      </main>
    </div>
  </FocusTrap>
</template>

<script>
import { FocusTrap } from 'focus-trap-vue'

export default {
  components: {
    FocusTrap,
  },
  emits: ['close'],
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped lang="scss">
header {
  height: 50px;
  line-height: 50px;
}

.overlay-container {
  position: absolute;
  height: 100%;
  border-left: 2px solid var(--color-border-default);
  background-color: rgba(var(--color-background-default-rgb), 0.95);
  width: 100%;
  z-index: var(--z-overlay);
  top: 0;
  right: 0;
  // transition: transform 0.5s;
  -webkit-transform: translateX(+100%);
  transform: translateX(+100%);
  visibility: hidden;
}

.overlay-container.opened {
  // transition: transform 0.5s;
  -webkit-transform: translateX(0);
  transform: translateX(0);
  visibility: visible;
}

.overlay-container > .overlay-content {
  position: relative;
  overflow: hidden;
  height: 100%;
}
.overlay-container > .overlay-content > .overlay-close {
  position: absolute;
  right: 0;
  margin: 1rem;
  z-index: 1;
}

.overlay-container > .overlay-content > .overlay-close:focus {
  color: var(--danger);
}

@media only screen and (min-width: 768px) {
  .overlay-container {
    width: auto;
  }
}
</style>
